import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTitle = styled.div`
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 30px;
  font-weight: 500;
  font-size: 13px;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.colors.textTitle};

  p {
    margin: 16px 0 0;
  }
`

export const StyledButtonGroup = styled.div`
  display: flex;
`

export const StyledButton = styled.button<{
  operateType: 'cancel' | 'confirm'
}>`
  flex: 1;
  background: ${({ operateType, theme }) =>
    operateType === 'confirm' ? theme.colors.primary : '#ffffff'};
  color: ${({ operateType, theme }) =>
    operateType === 'confirm' ? '#ffffff' : theme.colors.primary};
  border: ${({ operateType, theme }) =>
    operateType === 'confirm' ? 'none' : `1px solid ${theme.colors.primary}`};
  border-radius: 48px;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  padding: 12px 0;
  width: 100%;
  cursor: pointer;

  ${({ operateType }) =>
    operateType === 'cancel' &&
    css`
      margin-right: 10px;
    `}
`

export const StyledCancelButton = styled.button`
  margin-right: 10px;
`
